import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22fe4c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Information du produit", -1))
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "item-bloc-form p-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "info produit", -1))
const _hoisted_5 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_6 = { class: "item-bloc-form p-5" }
const _hoisted_7 = { class: "item-bloc-form p-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Fournisseur", -1))
const _hoisted_9 = {
  key: 0,
  class: "item-bloc-form p-5"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Gestion du stock", -1))
const _hoisted_11 = { class: "grid grid-cols-2 grid-rows-1 gap-6" }
const _hoisted_12 = {
  key: 1,
  class: "item-bloc-form p-5"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Connexions", -1))
const _hoisted_14 = {
  key: 2,
  class: "item-bloc-form p-5"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Redirection & réduction", -1))
const _hoisted_16 = {
  key: 3,
  class: "item-bloc-form p-5"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Code promotionnel", -1))
const _hoisted_18 = {
  key: 4,
  class: "item-bloc-form p-5"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Politique de prix", -1))
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-4" }
const _hoisted_21 = { class: "pr-5" }
const _hoisted_22 = { class: "pr-5" }
const _hoisted_23 = { class: "pr-5" }
const _hoisted_24 = { class: "pr-5" }
const _hoisted_25 = {
  key: 5,
  class: "item-bloc-form p-5"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Conditions d’utilisation", -1))
const _hoisted_27 = { class: "item-bloc-form p-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Géolocalisation", -1))

import ApiService from "@/_services/api.service"
import Property from "@/models/product/property/Property";
import PropertyValue from "@/models/product/property/PropertyValue";
import TagListOptions from "@/models/modules/formkit/TagListOptions";
import {computed, onMounted, Ref, ref, watch, onBeforeMount} from "vue";
import {useProductStore} from "@/stores/product/prototypeStore";
import {PRODUCT_PROTOTYPES, urssafClassification, urssafEvent} from "@/constants/product/properties";
import {taxes} from "@/constants/product/taxes";
import {useRoute} from 'vue-router'
import FormGeolocation from "@/components/forms/product/FormGeolocation.vue";
import {getOptionsCountry} from "@/_services/geolocation/country";

interface PropertyValuePayload {
  name: string;
  uuid: string;
}
const maximumDecimalsError = 'Maximum 2 décimales après la virgule.';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateInformationStep',
  props: {
  selectedPrototypeDefault: { type: String, required: true },
  productDataFromParent: { required: true },
  isDisabled: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

let optionsCountry = getOptionsCountry();

function getPrototype()
{
  return localStorage.getItem('prototype') ?? null ;
}

const driveOptions = [
  { label: 'Utilisable en drive', value: true },
  { label: 'Non utilisable en drive', value: false },
  { label: 'Information non renseignée', value: null }
];
const selectedDriveOption = ref(null);
const closure_reason = ref('');
const geolocationAddresses = ref([]);

let propertyBrand: Property;
let propertyUrssafEvent = ref({});
let allBrands = ref();
let propertyTaxes = ref({});
let is_sale_closed = ref();
let discount_type = ref();
let geolocationOptions = ref();
let typesGeolocationUuid = ref();
let geolocation_type = ref('');
let selectedBrand = ref();
let brands = ref();
let selectedBrandToSend: Ref<PropertyValuePayload | null> = ref(null);
let selectedBrandName = ref();
let is_discount = ref();
let publicPrice = ref();
let purchasingPrice= ref();
let geolocationApiKey = ref();
let reductionDescription = ref();
let reductionValue = ref();
let supplier_model = ref();
let supplier_model_name = ref();
let optionsShippingMethods = ref();
let shippingMethodModel  = ref();
let shippingMethodModelFromProduct = ref();
let loadShipping  = ref(1);
let loadBrand  = ref(1);
const route = useRoute();
let selectedUrssafClassification = ref('');
let selectedUrssafEvent = ref([]);
let selectedProductCollection = ref([]);
let  productCollectionOptions = ref([]);
let isLoadingCollections = ref(false);



let  selectedPrototype =ref() ;
let  productData =ref() ;

onBeforeMount(async () => {
  await getProductCollections();
  const productUuid = route.params.uuid;
  await getProduct(productUuid);
  await getBrand();
  await getTaxes();
  await getTypesGeolocationOptions();
  populateProductDataForm();
})

const getProduct = async (productUuid) => {
  try {
    const response = await ApiService.get("/variant-product/" + productUuid);
    productData.value= response.data.data ;
    selectedPrototype.value = response.data.data.prototype.uuid ;
  } catch (error) {
    console.error(error)
  }
}

const getProductCollections = async () => {
    isLoadingCollections.value = true;
    try {
        const response = await ApiService.get("/admin/variant_product_collection_all_for_grant");
        const collections = response.data.data || [];

        productCollectionOptions.value = collections.map(item => ({
            label: item.name,
            value: item.uuid
        }));
    } catch (error) {
        console.error("Erreur lors du chargement des collections :", error);
    } finally {
        isLoadingCollections.value = false;
    }
};


const promoCode = ref('');
const phoneNumber = ref('');

const phoneNumberValidation = computed(() => {
  if (promoCode.value && !phoneNumber.value) {
    return 'required';
  }
  return 'length:0,20';
});

function maxBrandLength(node) {
  const value = node.value
  return value[0]?.length <= 50;
}

watch(
  selectedBrand,
  (value) => {
    if (!value) {
      selectedBrandToSend.value = null;
      return;
    }
    if(loadBrand.value == 1){
      loadBrand.value =0;
      selectedBrandToSend.value  = {
        uuid: selectedBrand.value[0],
        name: selectedBrandName.value
      }
      return;
    } else{
      const nameValue = allBrands.value?.propertyValues.find((item: any) => item.uuid === selectedBrand.value[0])?.value;
      if(!nameValue){
        selectedBrandToSend.value  = {
          uuid: '',
          name: selectedBrand.value[0]
        }
      }else {
        selectedBrandToSend.value  = {
          uuid: selectedBrand.value[0],
          name: nameValue
        }
      }

    }
  },
  { immediate: true }
);

function maximumDecimals(node, maxDecimals = 2) {
  const value = node.value;
  const regex = new RegExp(`^\\d+(\\.\\d{1,${maxDecimals}})?$`);
  return regex.test(value);
}

function maximumDecimalsGeoloc(node, maxDecimals = 17) {
    const value = node.value;
    const regex = new RegExp(`^-?\\d+(\\.\\d{1,${maxDecimals}})?$`);
    return regex.test(value);
}

async function searchBrands({ search }) {
  if(!search || search.length <= 2)
  {
    if(selectedBrandName.value && selectedBrand?.value) return [
      {
        label: selectedBrandName.value,
        value: selectedBrand.value[0]
      }]
    else return [];
  }

  return propertyBrand.propertyValues.reduce((accumulator: Array<TagListOptions>, brand: PropertyValue) => {
    if (brand.value.toLowerCase().includes(search.toLowerCase())) {
      accumulator.push({
        label: brand.value,
        value: brand.uuid
      })
    }
    return accumulator;
  }, []);
}

async function getBrand() {
  const fetchedBrand = await ApiService.get('properties/e7cc42c0-fa45-11ed-a0b1-de1c3c38600f');
  propertyBrand = fetchedBrand.data.data;
  allBrands.value = propertyBrand;
}



async function getTaxes() {
  const fetchedTaxes = await ApiService.get('taxes');
  const taxOptions = Object.keys(fetchedTaxes.data.data).map((key) => ({
    value: fetchedTaxes.data.data[key].uuid,
    label: `${fetchedTaxes.data.data[key].tax.toString()}%`
  }));
  propertyTaxes.value = taxOptions;
}

function formatPropertyValueData(data) {
  return data.propertyValues.reduce((accumulator: Record<string, string>, propertyValue: PropertyValue) => {
    accumulator[propertyValue.uuid] = propertyValue.value;
    return accumulator;
  }, {});
}
async function getTypesGeolocationOptions() {
  const fetchTypesGeolocationOptions = await ApiService.get('properties/7d4e611a-2d5f-11ee-9793-de1ca4386011');
  typesGeolocationUuid.value = [];
  geolocationOptions.value = [];
  fetchTypesGeolocationOptions.data.data.propertyValues.forEach((val: any) => {
    typesGeolocationUuid.value[val.value] = val.uuid;
    let label = '';
    switch (val.value) {
      case 'Manual':
        label = 'Manuelle';
        break;
      case 'Api':
        label = 'Depuis l\'API';
        break;
      default:
        label = 'Géolocalisation désactivée';
    }
    geolocationOptions.value.push({
      label: label,
      value: val.uuid
    });



  });
}

async function searchSuppliers({search}) {
  if(!search || search.length <= 2) {
    return [
      {
        label: supplier_model_name.value,
        value: supplier_model.value
      }
    ];
  }

  const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
  return fetchSuppliers.data.data.map((val: any) => {
    return {
      label: val.name,
      value: val.uuid
    }
  });
}


watch(
  supplier_model,
  (value) => {
    if (!value) {
      optionsShippingMethods.value = [];
      shippingMethodModel.value = [];
      return;
    }
    let selectedShipping = [] ;
    shippingMethodModel.value= [] ;
    ApiService.get(`suppliers/${value}/shipping_methods?status=1&itemsPerPage=1000`).then(({data}) => {
      optionsShippingMethods.value = data.data.map((val: any) => {
        return {
          label: val.name,
          value: val.uuid
        }
      });
      if(loadShipping.value == 1){
        shippingMethodModel.value= shippingMethodModelFromProduct.value ;
        loadShipping.value = 0
      }

    });
  },
  { immediate: true }
);

const populateProductDataForm =  () => {
  try {
    selectedBrand.value  = [productData.value.specialProperty?.brand[0]?.uuid] ;
    selectedBrandName.value = productData.value.specialProperty?.brand[0]?.value ;

    publicPrice.value = productData.value.price?.publicPrice;
    reductionDescription.value = productData.value.price?.reductionDescription;
    reductionValue.value = productData.value.price?.reductionValue;

    supplier_model.value = productData.value.supplier?.uuid;
    supplier_model_name.value = productData.value.supplier?.value;
   
      let selectedShipping = [];
      for (const item of productData.value.shippingMethods) {
          selectedShipping.push(item.uuid);
      }
      shippingMethodModelFromProduct.value = selectedShipping;

  } catch (error) {
    // Gérez les erreurs ici
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_FormKit, {
          type: "text",
          name: "reference",
          label: "Référence produit*",
          placeholder: "Référence produit",
          validation: "required|length:0,255",
          "validation-messages": {
              required: 'Ce champ est obligatoire.',
              length: 'Ce champ doit contenir maximum 255 caractères.',
            },
          disabled: __props.isDisabled
        }, null, 8, ["validation-messages", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "hidden",
          name: "brand",
          modelValue: _unref(selectedBrandToSend),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedBrandToSend) ? (selectedBrandToSend).value = $event : selectedBrandToSend = $event)),
          disabled: __props.isDisabled
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "productName",
          label: "Nom du produit dans la boutique*",
          validation: "length:0,255|required",
          "validation-messages": {
              required: 'Ce champ est obligatoire.',
              length: 'Ce champ doit contenir maximum 255 caractères.',
            },
          placeholder: "Nom du produit dans la boutique",
          disabled: __props.isDisabled
        }, null, 8, ["validation-messages", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "adminProductName",
          label: "Nom du produit dans le backoffice",
          placeholder: "Nom du produit dans le backoffice",
          validation: "length:0,255",
          "validation-messages": {
              length: 'Ce champ doit contenir maximum 255 caractères.',
            },
          disabled: __props.isDisabled
        }, null, 8, ["validation-messages", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "shortDescription",
          label: "Description courte",
          placeholder: "Description courte",
          validation: "length:0,255",
          "validation-messages": {
              length: 'Ce champ doit contenir maximum 255 caractères.',
            },
          disabled: __props.isDisabled
        }, null, 8, ["validation-messages", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "select",
          name: "urssafClassification",
          label: "Sélectionner une catégorie",
          placeholder: "Sélectionner une catégorie",
          options: _unref(urssafClassification).values,
          modelValue: _unref(selectedUrssafClassification),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedUrssafClassification) ? (selectedUrssafClassification).value = $event : selectedUrssafClassification = $event)),
          disabled: __props.isDisabled
        }, null, 8, ["options", "modelValue", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "taglist",
          multiple: "",
          name: "urssafEvent",
          label: "Sélectionner un évènement",
          options: _unref(urssafEvent).values,
          modelValue: _unref(selectedUrssafEvent),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedUrssafEvent) ? (selectedUrssafEvent).value = $event : selectedUrssafEvent = $event)),
          disabled: __props.isDisabled
        }, null, 8, ["options", "modelValue", "disabled"]),
        (!_unref(isLoadingCollections))
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "taglist",
              name: "productCollections",
              label: "Sélectionner une/des Collection(s)",
              options: _unref(productCollectionOptions),
              modelValue: _ctx.selectedProductCollections,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedProductCollections) = $event)),
              multiple: ""
            }, null, 8, ["options", "modelValue"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, "Chargement des collections..."))
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("ProductForm.StatusBloc.title")), 1),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label:  _ctx.$t('ProductForm.StatusBloc.status') ,
          name: "active",
          value: true,
          disabled: __props.isDisabled
        }, null, 8, ["label", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label:  _ctx.$t('ProductForm.StatusBloc.closedLabel') ,
          name: "closedSale",
          modelValue: _unref(is_sale_closed),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(is_sale_closed) ? (is_sale_closed).value = $event : is_sale_closed = $event)),
          disabled: __props.isDisabled
        }, null, 8, ["label", "modelValue", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label:  _ctx.$t('ProductForm.StatusBloc.hiddenLabel') ,
          name: "hiddenProduct",
          disabled: __props.isDisabled
        }, null, 8, ["label", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "date",
          name: "enableDate",
          label: "Date d'activation",
          disabled: __props.isDisabled
        }, null, 8, ["disabled"]),
        _createVNode(_component_FormKit, {
          type: "date",
          name: "disabledDate",
          label: "Date de désactivation",
          disabled: __props.isDisabled
        }, null, 8, ["disabled"]),
        (_unref(is_sale_closed))
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "text",
              label: "Motif de la fermeture*",
              validation: "required|length:0,255",
              "validation-messages": {
              required: 'Ce champ est obligatoire.',
              length: 'Ce champ doit contenir maximum 255 caractères.'
            },
              name: "saleClosingReason",
              modelValue: closure_reason.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((closure_reason).value = $event)),
              disabled: __props.isDisabled
            }, null, 8, ["validation-messages", "modelValue", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_7, [
        _hoisted_8,
        (  
            getPrototype() !== _unref(PRODUCT_PROTOTYPES).PROMO &&
            getPrototype() !== _unref(PRODUCT_PROTOTYPES).MEMBER
          )
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "checkbox",
              label: "Envoi différé",
              name: "delayedSending",
              disabled: __props.isDisabled
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (getPrototype() !== _unref(PRODUCT_PROTOTYPES).PROMO &&
                getPrototype() !== _unref(PRODUCT_PROTOTYPES).MEMBER
          )
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 1,
              type: "taglist",
              multiple: "",
              label: "Moyen d’expédition*",
              name: "shippingMethod",
              placeholder: "Sélectionner un moyen d'expedition",
              validation: "required",
              disabled: __props.isDisabled,
              options: _unref(optionsShippingMethods),
              modelValue: _unref(shippingMethodModel),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(shippingMethodModel) ? (shippingMethodModel).value = $event : shippingMethodModel = $event)),
              "validation-messages": {
                required: 'Au moins un moyen d’expédition doit être associé au produit.',
              }
            }, null, 8, ["disabled", "options", "modelValue", "validation-messages"]))
          : _createCommentVNode("", true)
      ]),
      (getPrototype() !== _unref(PRODUCT_PROTOTYPES).PROMO && 
              getPrototype() !== _unref(PRODUCT_PROTOTYPES).MEMBER
        )
        ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_FormKit, {
              type: "checkbox",
              label: "Stock partagé",
              name: "isSharedStock",
              disabled: __props.isDisabled
            }, null, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_FormKit, {
                type: "number",
                label: "Stock*",
                palceholder: "Stock",
                name: "stock",
                validation: "required|matches:/^\\d+$/",
                disabled: __props.isDisabled,
                "validation-messages": {
              required: 'Ce champ est obligatoire.',
              matches: 'Veuillez entrer un nombre entier.'
          }
              }, null, 8, ["disabled", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "number",
                name: "stockAlertThreshold",
                label: "Seuil rupture de stock",
                palceholder: "Seuil rupture de stock",
                validation: "matches:/^\\d+$/",
                "validation-messages": {
                matches: 'Veuillez entrer un nombre entier.'
            },
                disabled: __props.isDisabled
              }, null, 8, ["validation-messages", "disabled"])
            ]),
            _createVNode(_component_FormKit, {
              type: "number",
              label: "Limite/panier",
              name: "limitByCart",
              validation: "matches:/^\\d+$/",
              "validation-messages": {
              matches: 'Veuillez entrer un nombre entier.'
          },
              disabled: __props.isDisabled
            }, null, 8, ["validation-messages", "disabled"]),
            _createVNode(_component_FormKit, {
              type: "number",
              label: "Limite/user",
              name: "limitByUser",
              validation: "matches:/^\\d+$/",
              "validation-messages": {
              matches: 'Veuillez entrer un nombre entier.'
          },
              disabled: __props.isDisabled
            }, null, 8, ["validation-messages", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (getPrototype() == _unref(PRODUCT_PROTOTYPES).PROMO )
        ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Identifiant",
              name: "identifiant",
              validation: "length:0,100",
              "validation-messages": {
                  length: 'Ce champ doit contenir maximum 100 caractères.',
                },
              disabled: __props.isDisabled
            }, null, 8, ["validation-messages", "disabled"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Mot de passe",
              name: "password",
              validation: "length:0,100",
              "validation-messages": {
                  length: 'Ce champ doit contenir maximum 100 caractères.',
                },
              disabled: __props.isDisabled
            }, null, 8, ["validation-messages", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (getPrototype() !== _unref(PRODUCT_PROTOTYPES).TICKET && 
              getPrototype() !== _unref(PRODUCT_PROTOTYPES).PHYSICAL && 
              getPrototype() !==_unref(PRODUCT_PROTOTYPES).GIFT
        )
        ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_FormKit, {
              type: "text",
              name: "redirectionLink",
              label: "Lien de redirection",
              placeholder: "https://www.example.com...",
              validation: "length:0,1400",
              "validation-messages": {
              length: 'Ce champ doit contenir maximum 1400 caractères.',
            },
              disabled: __props.isDisabled
            }, null, 8, ["validation-messages", "disabled"]),
            _createVNode(_component_FormKit, {
              type: "radio",
              label: "Type de réduction",
              name: "reductionType",
              options: [
              {label : 'Champ libre', value : 1},
              {label : 'En Pourcentage %', value : 2},
              {label : 'En euros €', value : 3}
          ],
              modelValue: _unref(discount_type),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(discount_type) ? (discount_type).value = $event : discount_type = $event)),
              validation: "required",
              disabled: __props.isDisabled
            }, null, 8, ["modelValue", "disabled"]),
            (_unref(discount_type) == 1)
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 0,
                  type: "textarea",
                  name: "reductionDescription",
                  label: "Description de la réduction*",
                  validation: "required|length:0,255",
                  "validation-messages": {
              length: 'Ce champ doit contenir maximum 255 caractères.',
              required: 'Ce champ est obligatoire.',
            },
                  modelValue: _unref(reductionDescription),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(reductionDescription) ? (reductionDescription).value = $event : reductionDescription = $event)),
                  disabled: __props.isDisabled
                }, null, 8, ["validation-messages", "modelValue", "disabled"]))
              : (_openBlock(), _createBlock(_component_FormKit, {
                  key: 1,
                  type: "number",
                  name: "reductionValue",
                  label: "Réduction*",
                  validation: "required|matches:/^[0-9]\\d*$/",
                  "validation-messages": {
            required: 'Ce champ est obligatoire.',
            matches: 'Veuillez entrer un nombre entier positif.'
          },
                  disabled: __props.isDisabled,
                  modelValue: _unref(reductionValue),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(reductionValue) ? (reductionValue).value = $event : reductionValue = $event))
                }, null, 8, ["validation-messages", "disabled", "modelValue"]))
          ]))
        : _createCommentVNode("", true),
      (getPrototype() !== _unref(PRODUCT_PROTOTYPES).TICKET && 
            getPrototype() !== _unref(PRODUCT_PROTOTYPES).PHYSICAL && 
            getPrototype() !==_unref(PRODUCT_PROTOTYPES).GIFT &&
            getPrototype() !==_unref(PRODUCT_PROTOTYPES).MEMBER
      )
        ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_FormKit, {
              type: "text",
              name: "webPromoCode",
              label: "Code promo internet",
              validation: "length:0,255",
              "validation-messages": {
            length: 'Ce champ doit contenir maximum 255 caractères.',
          },
              disabled: __props.isDisabled
            }, null, 8, ["validation-messages", "disabled"]),
            _createVNode(_component_FormKit, {
              type: "tel",
              label: "Numéro de téléphone",
              name: "phone",
              placeholder: "xx xx xx xx",
              modelValue: phoneNumber.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((phoneNumber).value = $event)),
              validation: phoneNumberValidation.value,
              "validation-messages": {
            length: 'Ce champ doit contenir maximum 20 caractères.',
            required: 'Ce champ est obligatoire si le code promo est renseigné.',
          },
              "validation-visibility": "dirty",
              disabled: __props.isDisabled
            }, null, 8, ["modelValue", "validation", "validation-messages", "disabled"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Code promo téléphone",
              name: "codePromoPhone",
              modelValue: promoCode.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((promoCode).value = $event)),
              validation: "length:0,255",
              "validation-messages": {
            length: 'Ce champ doit contenir maximum 255 caractères.',
          },
              disabled: __props.isDisabled
            }, null, 8, ["modelValue", "validation-messages", "disabled"]),
            _createVNode(_component_FormKit, {
              type: "number",
              step: "any",
              label: "Prix d’appel",
              name: "callPrice",
              "validation-rules": { maximumDecimals: maximumDecimals },
              validation: "length:0,20|maximumDecimals",
              "validation-messages": {
            length: 'Ce champ doit contenir maximum 20 caractères.',
            maximumDecimals: maximumDecimalsError,
          },
              disabled: __props.isDisabled
            }, null, 8, ["validation-rules", "validation-messages", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (
            getPrototype() !== _unref(PRODUCT_PROTOTYPES).PROMO && 
            getPrototype() !== _unref(PRODUCT_PROTOTYPES).MEMBER
        )
        ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_FormKit, {
                  type: "select",
                  label: "Monnaie",
                  name: "country",
                  options: [
                {label :'€',value :'FR', attrs: { disabled: false }},
                {label :'$',value :'EN',  attrs: { disabled: true }}
              ],
                  disabled: __props.isDisabled
                }, null, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_FormKit, {
                  type: "number",
                  step: "any",
                  label: "Prix de vente*",
                  "validation-rules": { maximumDecimals: maximumDecimals },
                  validation: "required|maximumDecimals",
                  "validation-messages": {
                  required: 'Ce champ est obligatoire.',
                  maximumDecimals: maximumDecimalsError,
              },
                  name: "price",
                  disabled: __props.isDisabled
                }, null, 8, ["validation-rules", "validation-messages", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_FormKit, {
                  type: "select",
                  label: "Taxes*",
                  name: "tax",
                  placeholder: "Sélectionner une taxe",
                  validation: "required",
                  "validation-messages": {
                required: 'Ce champ est obligatoire.',
              },
                  options: _unref(taxes).values,
                  disabled: __props.isDisabled
                }, null, 8, ["validation-messages", "options", "disabled"])
              ]),
              _createElementVNode("div", null, [
                (_unref(is_discount) == 1)
                  ? (_openBlock(), _createBlock(_component_FormKit, {
                      key: 0,
                      type: "number",
                      step: "any",
                      label: "Prix public*",
                      name: "publicPrice",
                      "validation-rules": { maximumDecimals: maximumDecimals },
                      validation: "required|maximumDecimals",
                      "validation-messages": {
                  required: 'Ce champ est obligatoire.',
                  maximumDecimals: maximumDecimalsError,
              },
                      disabled: __props.isDisabled,
                      modelValue: _unref(publicPrice),
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(publicPrice) ? (publicPrice).value = $event : publicPrice = $event))
                    }, null, 8, ["validation-rules", "validation-messages", "disabled", "modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_FormKit, {
                  type: "number",
                  step: "any",
                  label: "Prix d’achat",
                  name: "purchasingPrice",
                  "validation-rules": { maximumDecimals: maximumDecimals },
                  validation: "maximumDecimals",
                  "validation-messages": {
                  maximumDecimals: maximumDecimalsError,
              },
                  modelValue: _unref(purchasingPrice),
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(purchasingPrice) ? (purchasingPrice).value = $event : purchasingPrice = $event)),
                  disabled: __props.isDisabled
                }, null, 8, ["validation-rules", "validation-messages", "modelValue", "disabled"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_FormKit, {
                type: "radio",
                label: "Type de réduction",
                name: "reductionTypeAsReduction",
                options: [
                {label : 'Pas de réduction', value : 2},
                {label : 'Prix avec réduction', value : 1}
              ],
                validation: "required",
                modelValue: _unref(is_discount),
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(is_discount) ? (is_discount).value = $event : is_discount = $event)),
                disabled: __props.isDisabled
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]))
        : _createCommentVNode("", true),
      (getPrototype() !== _unref(PRODUCT_PROTOTYPES).TICKET && 
              getPrototype() !== _unref(PRODUCT_PROTOTYPES).PHYSICAL && 
              getPrototype() !== _unref(PRODUCT_PROTOTYPES).PROMO&& 
              getPrototype() !== _unref(PRODUCT_PROTOTYPES).MEMBER
      )
        ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_FormKit, {
              type: "checkbox",
              label: "Utilisable en magasin",
              name: "usableInStore",
              value: true,
              disabled: __props.isDisabled
            }, null, 8, ["disabled"]),
            _createVNode(_component_FormKit, {
              type: "checkbox",
              label: "Utilisable en ligne",
              name: "usableOnline",
              value: true,
              disabled: __props.isDisabled
            }, null, 8, ["disabled"]),
            _createVNode(_component_FormKit, {
              type: "radio",
              label: "Utilisation drive",
              name: "usableInDrive",
              options: driveOptions,
              modelValue: selectedDriveOption.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedDriveOption).value = $event)),
              disabled: __props.isDisabled
            }, null, 8, ["modelValue", "disabled"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", null, [
          _createVNode(_component_FormKit, {
            type: "checkbox",
            label: "Géolocalisation partagée",
            name: "isSharedGeolocations",
            disabled: __props.isDisabled
          }, null, 8, ["disabled"]),
          (_unref(geolocationOptions))
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "radio",
                label: "Type de récupération des adresses",
                name: "geolocationType",
                options: _unref(geolocationOptions),
                modelValue: _unref(geolocation_type),
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(geolocation_type) ? (geolocation_type).value = $event : geolocation_type = $event)),
                validation: "required",
                disabled: __props.isDisabled
              }, null, 8, ["options", "modelValue", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (_unref(typesGeolocationUuid) && (_unref(geolocation_type) == _unref(typesGeolocationUuid)['Api']))
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "text",
                name: "geolocationApiKey",
                label: "Recherche dans l'API",
                validation: "required|length:0,200|matches:/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\\s]+$/",
                "validation-messages": {
              length: 'Ce champ doit contenir maximum 200 caractères.',
              required: 'Ce champ est obligatoire.',
              matches: 'Seuls les lettres et les nombres sont acceptés.'
            },
                modelValue: _unref(geolocationApiKey),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(geolocationApiKey) ? (geolocationApiKey).value = $event : geolocationApiKey = $event)),
                disabled: __props.isDisabled
              }, null, 8, ["validation-messages", "modelValue", "disabled"]))
            : _createCommentVNode("", true),
          (_unref(typesGeolocationUuid) && (_unref(geolocation_type) == _unref(typesGeolocationUuid)['Manual']))
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 1,
                id: "repeater",
                name: "geolocationAddresses",
                type: "repeater",
                label: "Adresses",
                "add-label": "+",
                min: "1",
                max: "10",
                modelValue: geolocationAddresses.value,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((geolocationAddresses).value = $event)),
                disabled: __props.isDisabled
              }, {
                default: _withCtx(({ index }) => [
                  _createVNode(FormGeolocation, {
                    index: index,
                    number: index + 1,
                    reference: geolocationAddresses.value[index],
                    optionsCountry: _unref(optionsCountry)
                  }, null, 8, ["index", "number", "reference", "optionsCountry"])
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})